import React, { useState } from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography, Button } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { BulletItem } from '../utils/BulletItem';
import { PocBox } from '../utils/PocBox';

export default function StepValidation({ classes }: { classes: any }) {
  const [validated, setValidated] = useState(false);

  const validateCurl = `curl -X GET 'https://api.cat.com/assets/v2/assets' \\
  -H 'Authorization: Bearer YOUR_ACCESS_TOKEN'`;

  return (
    <>
      <Typography variant="body2" style={{ color: '#757575', marginBottom: 20 }}>
        Once your access is configured, perform a final validation to confirm everything works end-to-end.
      </Typography>

      <Accordion className={classes.subAccordion} defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography className={classes.subAccordionSummary}>1 — Generate a fresh token</Typography>
        </AccordionSummary>
        <AccordionDetails className={classes.subAccordionDetails} style={{ display: 'flex', flexDirection: 'column' }}>
          <BulletItem text="Follow the token generation steps from Step 2." classes={classes} />
          <BulletItem text="Ensure you are using credentials for the correct environment (QA or PROD)." classes={classes} />
          <BulletItem text="Tokens are short-lived — generate a fresh one for validation." classes={classes} />
        </AccordionDetails>
      </Accordion>

      <Accordion className={classes.subAccordion}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography className={classes.subAccordionSummary}>2 — Call a Requested endpoint</Typography>
        </AccordionSummary>
        <AccordionDetails className={classes.subAccordionDetails} style={{ display: 'flex', flexDirection: 'column' }}>
          <div className={classes.codeBlock}>
            <pre style={{ margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>{validateCurl}</pre>
          </div>
          <BulletItem text="Replace YOUR_ACCESS_TOKEN with the token from Step 1." classes={classes} />
          <BulletItem text="Substitute the endpoint URL with one from your authorized API product, ensuring the proper environment (QA or Prod) is selected and all required parameters are included." classes={classes} />
          <BulletItem text="A successful call returns HTTP 200 OK with the requested data, confirming your access is working properly." classes={classes} />
        </AccordionDetails>
      </Accordion>

      <Accordion className={classes.subAccordion}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography className={classes.subAccordionSummary}>3 — Confirm access</Typography>
        </AccordionSummary>
        <AccordionDetails className={classes.subAccordionDetails} style={{ display: 'flex', flexDirection: 'column' }}>
          <BulletItem text="HTTP 200 OK = success. Your onboarding is complete." classes={classes} />
          <BulletItem text="HTTP 401 = token issue. Regenerate and retry." classes={classes} />
          <BulletItem text="HTTP 403 = access not yet provisioned. Contact your POC." classes={classes} />
          <BulletItem text="HTTP 404 = wrong endpoint. Check your API product mapping." classes={classes} />
        </AccordionDetails>
      </Accordion>

      {!validated ? (
        <div style={{ textAlign: 'center', marginTop: 24 }}>
          <Button
            variant="contained"
            className={classes.btnPrimary}
            onClick={() => setValidated(true)}
            startIcon={<CheckCircleIcon />}
          >
            Mark Validation Complete
          </Button>
        </div>
      ) : (
        <div className={classes.validationSuccess} style={{ marginTop: 24 }}>
          <CheckCircleIcon className={classes.validationIcon} />
          <Typography variant="h6" style={{ fontWeight: 800, color: '#2E7D32', marginBottom: 6 }}>
            Onboarding Complete!
          </Typography>
          <Typography style={{ color: '#388E3C', fontSize: 14 }}>
            Your API access has been validated. You are ready to integrate.
          </Typography>
        </div>
      )}

      <PocBox
        classes={classes}
        contact="Service Adoption Team"
        email="Service_Adoption_Team_Cosmos@cat.com"
        issues={['401 after fresh token', '403 despite approved request', 'Endpoint returning 404', 'Data mismatch in response']}
      />
    </>
  );
}